import React, { useEffect } from "react"
import Head from "next/head"
import Layout from "../../components/Layout"
import TextHeader from "../../components/TextHeader"
import Header from "./Header"
import Services from "./Services"
import BookAppointment from "../../components/BookAppointment"
import { useTranslation, useLanguageQuery } from "next-export-i18n"
const Index = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  //since we are using next export i18n we need to add this useEffect to make sure the html lang attribute is set to the correct language

  useEffect(() => {
    let lang = query?.lang == "fr" ? "fr" : "en"
    document.querySelector("html").setAttribute("lang", lang)
  }, [query])

  return (
    <div>
      <Layout>
        <Head>
          <link rel="icon" href="/favicon.ico" />
        </Head>
        <Header />
        <Services />
        <BookAppointment />
      </Layout>
    </div>
  )
}

export default Index
